// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1qxi1","bigColWidth":"Table_bigColWidth__2CU9s","biggerColWidth":"Table_biggerColWidth__3LBRy","row":"Table_row__E2nPs","col":"Table_col__3U-v_"};